/* unplugin-vue-components disabled */import script from "./MessageReminder.vue?vue&type=script&setup=true&name=ApplicationClassification&lang=js"
export * from "./MessageReminder.vue?vue&type=script&setup=true&name=ApplicationClassification&lang=js"

import "./MessageReminder.vue?vue&type=style&index=0&id=a7ab11ae&lang=scss&scoped=true"

import exportComponent from "E:\\new-admin\\3.0\\ruoyi-vue3-cli\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7ab11ae"]])

export default __exports__